import PublicPackageApi from '@/api/public'

export default {
  namespaced: true,
  state: {
    sensorUid: null,
    loading: false,
    error: null,
  },

  actions: {
    async getItem(ctx, id) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);
      try {
        const { data } = await PublicPackageApi.getShipment({ hash: id });
        ctx.commit('setItem', data);
      } catch (error) {
        ctx.dispatch('errors/pushError', { id: 'shipments', error: error.message }, { root: true });
        ctx.commit('setError', error);
      } finally {
        ctx.commit('setLoading', false);
      }
    },
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },

    setError(state, err) {
      state.error = err;
    },

    setMeta(state, meta) {
      state.meta = meta;
    },

    setItem(state, item) {
      state.item = item;
    },

    setSensorUid(state, value) {
      state.sensorUid = value;
    },
  },

  getters: {
    meta: state => state.meta,
    error: state => state.error,
    loading: state => state.loading,
    item: state => state.item,
    sensorUid: state => state.sensorUid
  }
};
